import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/vercel/path0/apps/site/app/layouts/account.vue").then(m => m.default || m)),
  blank: defineAsyncComponent(() => import("/vercel/path0/apps/site/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/apps/site/app/layouts/default.vue").then(m => m.default || m)),
  "no-header": defineAsyncComponent(() => import("/vercel/path0/apps/site/app/layouts/noHeader.vue").then(m => m.default || m)),
  preorder: defineAsyncComponent(() => import("/vercel/path0/apps/site/app/layouts/preorder.vue").then(m => m.default || m))
}